import React from 'react';

import classes from './navigationItems.css';

import NavigationItem from './NavigationItem/navigationItem';

import {connect} from 'react-redux';



const navigationItems=(props)=>{
    
 
    
    
    return(
    
        <ul className={classes.NavigationItems}>
    
            <NavigationItem link='/' exact>Home</NavigationItem>
            {props.isLogged? <NavigationItem link='/drivers'>Drivers</NavigationItem>: null}
            <NavigationItem link='/hof'>Hall of Fame</NavigationItem>
            <NavigationItem link='/teams'>Teams</NavigationItem>
            {props.isLogged && !props.isExisting && props.currentUser!=='visitor@gmail.com'? <NavigationItem link='/info'>Info Form</NavigationItem>: null}
            {!props.isLogged? <NavigationItem link='/auth'>Authenticate</NavigationItem>:<NavigationItem link='/logout'>Logout</NavigationItem>}
    
        </ul>
    
    );
}


const mapStateToProps=state=>{//mapStateToProps is commonly used name, but you could name it differently. The state is Redux state. Note: create this constant after the class above
    
    return {
    
        isExisting: state.fetch.existing,
        isLogged: state.auth.token !== null,
        currentUser: state.auth.user
    };
}

//Read React instructions 86) to learn why we and how we use "exact" here in NavigationItem

export default connect(mapStateToProps)(navigationItems);


// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationItems/navigationItems.js